import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Figma "Container" (546:43 on the homepage, 974:311 on blog posts) — shared closing CTA band.
// Founder's wording (Oct 9 2026): the two paid reports, one per journey. `ctaHref`
// is kept for callers but no longer used.
// eslint-disable-next-line no-unused-vars
const ClosingCtaSection = ({ ctaHref = '/v2/me' }) => (
  <section className="py-[70px] px-6 lg:px-24">
    <div className="container mx-auto max-w-[1188px]">
      <div
        className="overflow-hidden relative flex flex-col-reverse md:flex-row items-center gap-8 md:gap-0 px-6 md:px-14 py-8 md:py-10"
        style={{ background: '#0e1d33', borderRadius: 32 }}
      >
        <img
          src="/cta-swirl-gold.svg"
          alt=""
          aria-hidden="true"
          className="absolute pointer-events-none select-none hidden md:block"
          style={{ width: 830, left: 400, top: 56, transform: 'rotate(-24.52deg)' }}
        />
        <div className="space-y-6 relative z-10 md:flex-1 w-full">
          <h2 className="font-heading font-medium text-[28px] sm:text-4xl leading-10 max-w-[458px] text-white">
            Your assessment takes a few minutes.
          </h2>
          <div className="flex flex-col sm:flex-row gap-6">
            <Link to="/v2/single">
              <Button className="w-full sm:w-auto h-14 pl-8 pr-7 rounded-xl font-medium hover:opacity-90" style={{ background: '#f1b200', color: '#08111f' }}>
                Marriage Readiness Report <ArrowRight className="w-5 h-5 ml-1" />
              </Button>
            </Link>
            <Link to="/couple">
              <Button className="w-full sm:w-auto h-14 pl-8 pr-7 rounded-xl font-medium hover:opacity-90" style={{ background: '#f1b200', color: '#08111f' }}>
                Couple Compatibility Report <ArrowRight className="w-5 h-5 ml-1" />
              </Button>
            </Link>
          </div>
          <p className="text-xl font-medium leading-7" style={{ color: '#d9e4f5' }}>Or take your time. We'll be here.</p>
        </div>
        <div className="relative z-10 w-full md:w-[383px] flex-shrink-0">
          <img src="/closing-cta-couple.webp" alt="A couple celebrating their engagement, found through SoulSathiya" className="w-full rounded-[15px] aspect-[4/3] md:h-[292px] md:aspect-auto object-cover" loading="lazy" />
        </div>
      </div>
    </div>
  </section>
);

export default ClosingCtaSection;
